export default __webpack_public_path__ + "static/media/kknjsinvoice.65d18a2b.jpg";